import "@mdi/font/css/materialdesignicons.css"
import Vue from 'vue';
import Vuetify from 'vuetify';

Vue.use(Vuetify);

export default new Vuetify({
    lang: {
        locales: { ko: require("vuetify/lib/locale/ko") },
        current: 'ko',
    },
    theme: {
        themes: {
            light: {
                primary: '#00C73C',
                secondary: '#445163',
                accent: '#00C73C',
                // error: '#FF5252',
                info: '#2D3539',
                content: "#EDF0F5",
                // success: '#4CAF50',
                // warning: '#FFC107',
            },
            // dark: {
            //     primary: colors.purple.base,
            //     secondary: '#424242',
            //     accent: '#82B1FF',
            //     error: '#FF5252',
            //     info: '#2196F3',
            //     success: '#4CAF50',
            //     warning: '#FFC107',
            // }
        }
    }
});